import React from "react";
import { compose, branch, renderComponent, renderNothing } from "recompose";
import { withUserInfo } from "app/auth/hocs";
import { USER_INFO } from "./constants";
import { Icon } from "@blueprintjs/core";

const renderUserId = renderComponent(props => {
  return <span>{props.userId}</span>;
});

const enhance = compose(
  withUserInfo,
  branch(props => !props.userId, renderNothing),
  branch(props => !props.user, renderUserId),
  branch(props => !props.user[USER_INFO.SUCCESS], renderUserId)
);

const UserInfo = enhance(props => {
  const { userId, user } = props;
  return (
    <span>
      <span className="icon">
        <Icon iconName="comment" />{" "}
      </span>
      {user.name || user.fullName || userId}
    </span>
  );
});

export default UserInfo;



// WEBPACK FOOTER //
// ./src/app/auth/UserInfo.js